import { useState, useEffect } from 'react';

export function useDarkMode(): boolean {
  const [dark, setDark] = useState(() => document.body.dataset.theme !== 'light');
  useEffect(() => {
    const obs = new MutationObserver(() =>
      setDark(document.body.dataset.theme !== 'light')
    );
    obs.observe(document.body, { attributes: true, attributeFilter: ['data-theme'] });
    return () => obs.disconnect();
  }, []);
  return dark;
}
